import React from "react";
import styled from "styled-components";
import { Flex } from "../../../Flex";
import { OrderRow } from "../OrderRow";
import { TableHead } from "../../../TableHead";
import { layout, LayoutProps } from "styled-system";
import { Order } from "../../../../types/Order";

interface Props {
  className: string;
  headers: { Header: string }[];
  type: OrdersFilterStatus;
  orders: Order[];
}

const TableWrapper = styled.table<LayoutProps>`
  ${layout}
  border-collapse: collapse;
  width: 100%;
`;

const TableHeadWrapper = styled(TableHead)`
  border-color: ${({ theme }) => theme.colors.neutrals.ln30};
  white-space: nowrap;
  padding-left: 4px;
  padding-right: 4px;
`;

export const OrdersTable: React.FC<Props> = ({
  className,
  headers,
  type,
  orders,
}) => {
  return (
    <Flex flexDirection="column" className={className} mb={3}>
      <TableWrapper>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <TableHeadWrapper
                key={index}
                data-testid="order-header"
                pl={index === 0 ? 2 : 0}
                py={3}
                textAlign="left"
                backgroundColor="neutrals.ln10"
                borderTop="1px solid"
                borderBottom="1px solid"
                color="neutrals.mn80"
                fontWeight="medium"
                fontSize={0}
                lineHeight={0}
              >
                {header.Header}
              </TableHeadWrapper>
            ))}

            <TableHeadWrapper
              pr={2}
              py={3}
              textAlign="left"
              backgroundColor="neutrals.ln10"
              borderTop="1px solid"
              borderBottom="1px solid"
              color="neutrals.mn80"
              fontWeight="medium"
              fontSize={0}
              lineHeight={0}
            >
              {/* Empty by design for controls */}
            </TableHeadWrapper>
          </tr>
        </thead>

        <tbody>
          {orders.map((order, index) => (
            <OrderRow key={index} index={index} type={type} order={order} />
          ))}
        </tbody>
      </TableWrapper>
    </Flex>
  );
};
